import searchConstants from "../_constants/searchConstants";
import { updateObject, mapArrayToObject } from "../_utils";
import messagingConstants from "../_constants/messagingConstants";
import { reverse, concat } from "lodash";
import userConstants from "../_constants/userConstants";

const initialState = {
  conversations: {},
  lastResult: null,
  lastUpdated: null,
  chat: {
    id: null,
    messagingId: null,
    user: {},
    messages: [],
    isLastResult: false,
    newMessageAdded: true
  }
};

const getConversations = (state, action) => {
  return updateObject(state, {
    conversations: mapArrayToObject(action.payload)
  });
};
const clearConversations = (state, action) => {
  return updateObject(state, {
    conversations: {},
    chat: {
      id: null,
      messagingId: null,
      user: {},
      messages: [],
      isLastResult: false,
      newMessageAdded: true
    }
  });
};
const initializeChat = (state, action) => {
  const { messagingId, id } = action.payload;
  return updateObject(state, {
    chat: { messagingId, user: {}, messages: [], id }
  });
};
const clearChat = (state, action) => {
  return updateObject(state, {
    chat: {
      id: null,
      messagingId: null,
      user: {},
      messages: [],
      isLastResult: false,
      newMessageAdded: true
    }
  });
};
const getChatUserInformation = (state, action) => {
  return updateObject(state, {
    chat: updateObject(state.chat, { user: action.payload })
  });
};
const loadUpChatMessages = (state, action) => {
  return updateObject(state, {
    chat: updateObject(state.chat, {
      messages: concat(state.chat.messages, reverse(action.payload))
    })
  });
};
const updateParticipantImageUrl = (state, action) => {
  const { selectedId, image } = action.payload;
  return updateObject(state, {
    conversations: updateObject(state.conversations, {
      [selectedId]: updateObject(state.conversations[selectedId], {
        imageURL: image,
        user: updateObject(state.conversations[selectedId].user, {
          imageURL: image
        })
      })
    })
  });
};
const changeIsLastResultForChat = (state, action) => {
  return updateObject(state, {
    chat: updateObject(state.chat, { isLastResult: action.payload })
  });
};
const loadPreviousMessages = (state, action) => {
  return updateObject(state, {
    chat: updateObject(state.chat, {
      messages: concat(reverse(action.payload), state.chat.messages)
    })
  });
};
const changeNewMessageAddedFlag = (state, action) => {
  return updateObject(state, {
    chat: updateObject(state.chat, { newMessageAdded: action.payload })
  });
};
const loadMoreConversations = (state, action) => {
  return updateObject(state, {
    conversations: updateObject(
      state.conversations,
      mapArrayToObject(action.payload)
    )
  });
};
const changeLastResultForConversations = (state, action) => {
  return updateObject(state, {
    lastResult: action.payload
  });
};
/* ---------------------------------------------------
      SIGN OUT
  ----------------------------------------------------- */
const signOut = (state, action) => {
  return initialState;
};
const reducer = (state = initialState, action) => {
  switch (action.type) {
    case messagingConstants.GET_CONVERSATIONS:
      return getConversations(state, action);
    case messagingConstants.CLEAR_CONVERSATIONS:
      return clearConversations(state, action);
    case messagingConstants.INITIALIZE_CHAT:
      return initializeChat(state, action);
    case messagingConstants.CLEAR_CHAT:
      return clearChat(state, action);
    case messagingConstants.GET_CHAT_USER_INFORMATION:
      return getChatUserInformation(state, action);
    case messagingConstants.LOAD_UP_CHAT_MESSAGES:
      return loadUpChatMessages(state, action);
    case messagingConstants.UPDATE_PARTICIPANT_IMAGE_URL:
      return updateParticipantImageUrl(state, action);
    case messagingConstants.CHANGE_IS_LAST_RESULT_FOR_CHAT:
      return changeIsLastResultForChat(state, action);
    case messagingConstants.LOAD_PREVIOUS_MESSAGES:
      return loadPreviousMessages(state, action);
    case messagingConstants.CHANGE_NEW_MESSAGE_ADDED_FLAG:
      return changeNewMessageAddedFlag(state, action);
    case messagingConstants.CHANGE_LAST_RESULT_FOR_CONVERSATIONS:
      return changeLastResultForConversations(state, action);
    case messagingConstants.LOAD_MORE_CONVERSATIONS:
      return loadMoreConversations(state, action);
    case userConstants.SIGN_OUT:
      return signOut(state, action);
    default:
      return state;
  }
};

export default reducer;



// WEBPACK FOOTER //
// ./src/_reducers/messaginReducer.js